import { render, staticRenderFns } from "./TiposMovimentosForm.vue?vue&type=template&id=71b6bab2"
import script from "./TiposMovimentosForm.vue?vue&type=script&lang=js"
export * from "./TiposMovimentosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports